jQuery($ => {
  class UsefulMarketingModalToggle {
    constructor(element, args = {}) {
      this._ = element;
      this._element = $(element);
      this._toggle = this._element.find('.umktg-modal-toggle__toggle');
      this._toggleId = this._toggle.attr('id');

      this._args = $.extend({
        modalId: this._toggle.attr('aria-controls'),
        focusOnModal: false
      }, args);

      this._modal = $(`#${this._args.modalId}`);

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('umktg-modal-toggle:init', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._toggle.on('mousedown', this.handleToggleMousedown);
      this._toggle.on('keydown', this.handleToggleKeydown);
      this._modal.on('close', this.completeModalClose);
      this._element.on('umktg-modal-toggle:close', this.handleModalClose);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Check If Released
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    checkIfReleased = () => {
      const isReleased = this._element.hasClass('umktg-modal-toggle--released');
      return isReleased;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Modal Open
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleModalOpen = () => {
      // Check if there's another identical form in the page
      const formId = this._modal.attr('data-form-id');
      const instances = document.querySelectorAll(`#gform_wrapper_${formId}`);

      if (instances.length > 1) {
        // Get the form outside the modal
        const instance = Array.from(instances).find(instance => !$.contains(this._modal, instance));

        if (instance) {
          // And scroll to it
          const y = instance.getBoundingClientRect().top + window.pageYOffset + -220;
          window.scrollTo({ top: y, behavior: 'smooth' });
          return;
        }
      }

      // Close any open modals before opening the clicked one
      $('.umktg-modal--open').each(function() {
        $(this).umktg_modal('handleClose');
      });

      const toggle_count = $(`[aria-controls*="${this._args.modalId}"]`).length;

      if (toggle_count > 1) {
        this._modal.umktg_modal('setControlledby', this._toggleId);
      }

      this._modal.umktg_modal('handleOpen');
      this._toggle.addClass('umktg-modal-toggle--open');
      this._element.trigger('umktg-modal-toggle:open', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Modal Close
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleModalClose = () => {
      this._modal.umktg_modal('handleClose');
      this.completeModalClose();
    }

    completeModalClose = () => {
      this._toggle.removeClass('umktg-modal-toggle--open');
      this._element.trigger('umktg-modal-toggle:close', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Modal Toggle
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleModalToggle = () => {
      if (this._modal.hasClass('umktg-modal--open')) {
        this.handleModalClose();
      } else {
        this.handleModalOpen();
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Toggle Mousedown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleToggleMousedown = () => {
      if (this.checkIfReleased()) return;

      this.handleModalToggle();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Toggle Keydown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleToggleKeydown = event => {
      if (this.checkIfReleased()) return;

      switch (event.key) {
        case 'Enter':
        case 'spacebar':
        case ' ':
          event.preventDefault();

          this.handleModalOpen();
          break;
      }
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.umktg_modal_toggle = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].umktg_modal_toggle = new UsefulMarketingModalToggle(_[i], opt);
      else
        ret = _[i].umktg_modal_toggle[opt].apply(_[i].umktg_modal_toggle, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.umktg-modal-toggle').umktg_modal_toggle();
});